import "./svg/vipps-smiley-icon.svg"

export default {
    name: "vipps-smiley-icon",
    viewBox: "24 24",
}
